export default __webpack_public_path__ + "static/media/img-001.f4bfa081.svg";